// Client-side authentication utilities

export function isAuthenticated(): boolean {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem('isLoggedIn') === 'true';
}

export function getUserEmail(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem('userEmail');
}

export function getUserName(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem('userName');
}

export function getUserRole(): 'user' | 'admin' | null {
  if (typeof window === 'undefined') return null;
  const role = localStorage.getItem('userRole');
  return role as 'user' | 'admin' | null;
}

export function isAdmin(): boolean {
  return getUserRole() === 'admin';
}

export function logout(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem('isLoggedIn');
  localStorage.removeItem('userEmail');
  localStorage.removeItem('userName');
  localStorage.removeItem('userRole');
  localStorage.removeItem('kneePainData');
  localStorage.removeItem('chatHistory');
}
